/* THE FIVE MAIN GOALS' NAMES, as the phone prints them — `HybridTrainer/Models/MainGoal.swift`'s
 * `title`, his five, verbatim.
 *
 * ⚠️ TYPED HERE BECAUSE A ROSTER ROW NEEDS THE WORD, AND PINNED BECAUSE A SECOND COPY OF A VOCABULARY
 * IS HOW THIS REPO'S DEFINING BUG ARRIVES: the harness gate `w72-1-this-week` parses the Swift switch
 * and asserts this map equals it, key for key and word for word. Change one side and the suite goes
 * red before a coach reads a name the athlete never chose.
 *
 * The keys are the STORED slugs (`profiles.main_goals`). An unknown slug has no label — the caller
 * shows nothing rather than the slug, because a slug on a coach's screen is jargon. */
export const MAIN_GOAL_TITLE: Readonly<Record<string, string>> = {
  strength: "Get stronger",
  muscle: "Build muscle",
  skills: "Calisthenics skills",
  mobility: "Mobility & Flexibility",
  fitter: "Get fitter",
};

export function mainGoalTitle(slug: string | null): string | null {
  if (slug === null) return null;
  return MAIN_GOAL_TITLE[slug] ?? null;
}
